import { CLMButtonPrimary } from "../v3/Buttons";

const CTASection = ({ btnText, btnUrl }) => {
  return (
    <section className="bg-[#f4f2f0] text-black py-16  md:px-10 px-4 xl:px-20 text-center">
      <h1 className="text-4xl md:text-7xl font-semibold leading-snug md:mt-20 mt-4 max-w-screen-xl mx-auto mb-16 tracking-tight">
        Transform service with BoloSign's AI agent platform
      </h1>
      <CLMButtonPrimary buttonText={btnText} buttonUrl={btnUrl} />
    </section>
  );
};

export default CTASection;
